import DiscountsContainer from "./DiscountsContainer";
export default DiscountsContainer;
